// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { InvoiceSummaryModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { InvoiceDetail } from "@store/Framework/Types/types";
import { Draft } from "immer";

export type InvoiceDetailState = ApplicationState["bunzl"]["pages"]["InvoiceDetail"];
export type ReportAPIState = ApplicationState["bunzl"]["pages"]["ReportAPI"];
export type InvoiceSummaryState = ApplicationState["bunzl"]["pages"]["invoiceSummaryReportData"];

export const initialInvoiceSummaryState: InvoiceSummaryState = {
    invoiceSummaryReportData: undefined,
};

const initialInvoiceDetailState: InvoiceDetailState = {};

const initialReportAPIState: ReportAPIState = {
    poError: false,
    validationError: false,
};

export const invoiceDetailActions = {
    "Store/Pages/invoiceDetail/LoadInvoiceDetail": (
        draft: Draft<InvoiceDetailState>,
        action: { report: InvoiceDetail },
    ) => {
        draft.invoiceDetailReportData = action.report;
    },
};

export const reportAPIActions = {
    "Store/Pages/reportAPI/setPoError": (draft: Draft<ReportAPIState>, action: { action: boolean }) => {
        draft.poError = action.action;
    },
    "Store/Pages/reportAPI/setValidationError": (draft: Draft<ReportAPIState>, action: { action: boolean }) => {
        draft.validationError = action.action;
    },
};

export const invoiceSummarysactions = {
    "Store/Pages/invoiceSummarys/LoadInvoiceSummary": (
        draft: Draft<InvoiceSummaryState>,
        action: { report: InvoiceSummaryModel | undefined },
    ) => {
        draft.invoiceSummaryReportData = action.report;
    },
};

const invoiceDetailReducer = createTypedReducerWithImmer(initialInvoiceDetailState, invoiceDetailActions);
const reportAPIReducer = createTypedReducerWithImmer(initialReportAPIState, reportAPIActions);
const invoiceSummaryReducer = createTypedReducerWithImmer(initialInvoiceSummaryState, invoiceSummarysactions);
export type InvoiceDetailActions = BunzlActionUnion<typeof invoiceDetailActions>;
export type ReportAPIactions = BunzlActionUnion<typeof reportAPIActions>;
export type InvoiceSummaryActions = BunzlActionUnion<typeof invoiceSummarysactions>;
export default { reportAPIReducer, invoiceSummaryReducer, invoiceDetailReducer };
